import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const appointmentsReducerSelector = (state: RootState) => state.amwell.appointments;
export const appointmentsSelector = createSelector(appointmentsReducerSelector, a => a.list);
export const appointmentSelector = createSelector(appointmentsReducerSelector, a => a.details);

export const appointmentsDataSelector = createSelector(appointmentsSelector, a => a.data);
export const appointmentsErrorSelector = createSelector(appointmentsSelector, a => a.error);
export const appointmentsLoadingSelector = createSelector(appointmentsSelector, a => a.loading);

export const appointmentDataSelector = createSelector(appointmentSelector, a => a.data);
export const appointmentErrorSelector = createSelector(appointmentSelector, a => a.error);
export const appointmentLoadingSelector = createSelector(appointmentSelector, a => a.loading);
